<template>
  <div class="row">
    <div class="col-xl-4 col-lg-5 col-md-6 mx-auto">
      <user-card></user-card>
    
    </div>
  </div>
</template>
<script>

import UserCard from "./UserProfile/UserCard.vue";
export default {
  components: {
    UserCard
  },
};
</script>
<style></style>
